module.exports = __webpack_public_path__ + "static/media/battleMusic.a611398e.wav";